import { useSelector } from 'react-redux'

import { ReduxState } from '@/config/redux/types'

const selectActiveStepIndex = (state: ReduxState) =>
  state.signupState.activeStepIndex

const selectCurrentPageContent = (state: ReduxState) =>
  state.signupState.pageContent

const selectNextAction = (state: ReduxState) => state.signupState.nextAction

const selectSignupRoutes = (state: ReduxState) => state.signupState.signupRoutes

const selectEnvironment = (state: ReduxState) => state.signupState.environment
const selectVersion = (state: ReduxState) => state.signupState.version
const selectAbTestTracked = (state: ReduxState) =>
  state.signupState.abTestTracked

const selectCurrentRoute = (state: ReduxState) => {
  const activeStateIndex = selectActiveStepIndex(state)
  const routes = selectSignupRoutes(state)

  return routes[activeStateIndex]
}

const useActiveStepIndex = () => useSelector(selectActiveStepIndex)
const useCurrentPageContent = () => useSelector(selectCurrentPageContent)
const useNextAction = () => useSelector(selectNextAction)
const useSignupRoutes = () => useSelector(selectSignupRoutes)
const useEnvironment = () => useSelector(selectEnvironment)
const useVersion = () => useSelector(selectVersion)
const useCurrentRoute = () => useSelector(selectCurrentRoute)
const useAbTestTracked = () => useSelector(selectAbTestTracked)

export {
  useActiveStepIndex,
  useCurrentPageContent,
  useNextAction,
  useSignupRoutes,
  selectActiveStepIndex,
  useEnvironment,
  selectEnvironment,
  useCurrentRoute,
  selectVersion,
  useVersion,
  useAbTestTracked,
}
